module.exports = __webpack_public_path__ + "img/img1.da85acfa.svg";